import { IsNotEmpty, IsNumberString } from 'class-validator';

export class RouteDemoDataTypeDTO {

    @IsNotEmpty()
    @IsNumberString()
    type: string;

}
